export default __webpack_public_path__ + "static/media/perrinita5.5989f20b.jpg";